module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "usersuv"
  }, [_c('div', {
    staticClass: "usersuv-list",
    on: {
      "click": function($event) {
        _vm.latelyShow()
      }
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('router-link', {
    staticClass: "content border-1px",
    attrs: {
      "tag": "div",
      "to": {
        path: '/lately'
      }
    }
  }, [_c('h3', {
    staticClass: "list-title"
  }, [_vm._v("最近播放")]), _vm._v(" "), _c('span', {
    staticClass: "number"
  }, [_vm._v("(" + _vm._s(_vm.latelyLength ? _vm.latelyLength : 0) + ")")])])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "usersuv-list off"
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "content border-1px"
  }, [_c('h3', {
    staticClass: "list-title"
  }, [_vm._v("下载管理")]), _vm._v(" "), _c('span', {
    staticClass: "number"
  }, [_vm._v("(6)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "usersuv-list off"
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "content border-1px"
  }, [_c('h3', {
    staticClass: "list-title"
  }, [_vm._v("我的歌手")]), _vm._v(" "), _c('span', {
    staticClass: "number"
  }, [_vm._v("(2)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-a2b77796"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Usersub/Usersub.vue
// module id = 213
// module chunks = 1